<template>
  <section id="message" class="panel message" v-bind:class="{ hide: hidden }">
    <header class="panel--header">
      <h2 class="panel--title">Follow Up Session Note</h2>
      <a href="#" class="close panel--close" v-on:click="this.$emit('close')"
        >Close message</a
      >
    </header>
    <div class="panel--content">
      <div class="panel--main">

        <table class="person_details" aria-label="Patient information">
          <tbody>
            <tr>
              <th class="person_details--header" scope="row">
                {{ this.$root.config.mentor_label_singular }}
              </th>
              <td class="person_details--data">
                {{ sessionNote.mentor_name }}
              </td>
            </tr>
            <tr>
              <th class="person_details--header" scope="row">Meeting Type</th>
              <td class="person_details--data">
                {{ sessionNote.meeting_type }}
              </td>
            </tr>
            <tr>
              <th class="person_details--header" scope="row">Duration</th>
              <td class="person_details--data">
                {{ sessionNote.duration }} minutes
              </td>
            </tr>
            <tr>
              <th class="person_details--header" scope="row">Day</th>
              <td class="person_details--data">{{ sessionNote.day }}</td>
            </tr>
            <tr>
              <th class="person_details--header" scope="row">Date</th>
              <td class="person_details--data">
                <time>{{ sessionNote.meeting_date }}</time>
              </td>
            </tr>
            <tr>
              <th class="person_details--header" scope="row">
                {{ this.$root.config.mentee_label_singular }}
              </th>
              <td class="person_details--data">
                {{ sessionNote.mentee_name }}
              </td>
            </tr>
          </tbody>
        </table>
        <dl class="notes">
          <dt class="notes--definition">Topics Discussed</dt>
          <dd class="notes--description">
            <ul class="checklist checklist-notes">
              <li
                v-for="topic in sessionNote.topic_details"
                v-bind:key="topic.id" 
               >{{ topic.name }}</li>
            </ul>
          </dd>
          <dt class="notes--definition">Notes From Meeting</dt>
          <dd class="notes--description">
            <p v-dompurify-html="sessionNote.notes" />
          </dd>
          <dd class="notes--description">
            {{ $root.config.mentee_label_singular }} needs follow up by Care Team: <strong>{{ atRisk }}</strong>
          </dd>
          <dd class="notes--description">
            {{ $root.config.mentee_label_singular }} at-risk of leaving for another provider: <strong>{{ leavingProvider }}</strong>
          </dd>
        </dl>
      </div>
    </div>
  </section>
  <section
    id="admin_actions"
    class="panel admin_actions"
    v-bind:class="{ hide: hidden }"
  >
    <header class="panel--header">
      <h2 class="panel--title">Admin Actions</h2>
      <a href="#" class="close panel--close" v-on:click="this.$emit('close')"
        >Close message</a
      >
    </header>
    <div class="panel--content">
      <form class="panel--main" v-on:submit.prevent="submit">
        <div v-if="errorMessage" class="notice notice-error">
          {{ errorMessage }}
        </div>
        <div class="field field-text">
          <label for="comment" class="field--label"
            >Add a comment about this follow up:</label
          >
          <textarea
            id="comment"
            name="comment"
            v-model="sessionNote.action_notes"
            class="field--input field--input-textarea"
            rows="3"
            cols="30"
            v-bind:disabled="sessionNote.status !== 'open'"
          ></textarea>
        </div>
        <div class="field field-select">
          <label for="actions" class="field--label">Actions</label>
          <select
            name="actions"
            id="actions"
            v-model="sessionNote.action"
            class="field--select"
            v-bind:disabled="sessionNote.status !== 'open'"
          >
            <option value="" selected disabled="disabled">Please select</option>
            <option
              v-for="action in actions"
              v-bind:key="action.id"
              v-bind:value="action.id"
            >
              {{ action.title }}
            </option>
          </select>
        </div>
        <div class="field" v-if="sessionNote.status === 'open'">
          <IthButton
            type="submit"
            class="btn btn-submit"
            v-on:buttonClick="handleSave(false)"
            ref="saveButton"
          >
            Save
          </IthButton>
          <span class="field--submit_or">or</span>
          <IthButton
            v-on:buttonClick="handleSave(true)"
            v-bind:disabled="!okToClose"
            class="btn btn-submit btn-primary"
            ref="saveDoneButton"
          >
            Save <span class="btn--smalltext">and</span> mark as done
          </IthButton>
        </div>
        <section class="history">
          <!-- <h3 class="history--title">Actions History</h3>
          <ul class="history--content list list-simple">
            <li class="list--item">
              <a href="#"
                ><time class="history--date" datetime="2022-03-03"
                  >3 Mar 2022</time
                >
                – Added notes</a
              >
            </li>
          </ul> -->
        </section>
      </form>
    </div>
  </section>
</template>
<script>
import IthButton from "../components/IthButton.vue";
export default {
  name: "AdminUrgentMessage",

  emits: ["close", "closedUrgentAlert"],

  components: { IthButton },

  data() {
    return {
      hidden: true,
      sessionNote: {
        id: "",
        first_name: "",
        last_name: "",
        duration: null,
        meeting_reason: "",
        notes: "",
        mentor_name: "",
        mentee_name: "",
        action: "",
        action_notes: "",
        topics: [],
      },
      actions: [], // List of actions
      errorMessage: "",
      topics: [] // List of all sesson note topics
    };
  },

  computed: {
    // Can only close alert if at least one of action and action note is non-blank
    okToClose() {
      return (
        (this.sessionNote.action !== null && this.sessionNote.action !== "") ||
        (this.sessionNote.action_notes !== null &&
          this.sessionNote.action_notes !== "")
      );
    },
    atRisk() {
      return this.sessionNote.patient_at_risk ? this.$root.localize("global.yes") : this.$root.localize("global.no");
    },
    leavingProvider() {
      return this.sessionNote.risk_leaving_provider ? this.$root.localize("global.yes") : this.$root.localize("global.no");
    },
  },

  created() {
    this.$root.callAuthenticatedEndpoint(
      "getUrgentSessionNoteActions",
      (items) => {
        this.actions = items;
      }
    );
    this.$root.callAuthenticatedEndpointNEW(
      "getSessionNoteTopics",
      resp => this.topics = resp
    );
  },

  methods: {
    show(menteeId, sessionNoteId, mentorName, menteeName) {
      this.hidden = false;
      this.loadSessionNote(menteeId, sessionNoteId, mentorName, menteeName);
    },
    hide() {
      this.hidden = true;
    },
    loadSessionNote(menteeId, sessionNoteId, mentorName, menteeName) {
      console.log(sessionNoteId);
      this.$root.api.getUrgentSessionNotesByUser(
        menteeId,
        this.$root.user.token,
        (resp) => {
          resp.forEach((note) => {
            if (note.id === sessionNoteId) {
              this.sessionNote = note;
              this.sessionNote.day = this.$root.getDayOfWeek(
                this.sessionNote.meeting_date
              );
              this.sessionNote.meeting_date = this.$root.formatDate(
                note.meeting_date
              );
              this.sessionNote.mentor_name = mentorName;
              this.sessionNote.mentee_name = menteeName;
              this.sessionNote.topics = note.topics;
            }
          });
        }
      );
    },

    getTopicClass(topicId) {
      if (this.sessionNote.topic_details === undefined) {
        return "checklist--item-disabled";
      }
      const topicSelected = this.sessionNote.topic_details.find((t) => {
        return t.id == topicId
      });

      if (topicSelected) {
        return "checklist--item-checked";
      }
      return "checklist--item-disabled";
    },

    // Updates note and (optionally) closes it
    handleSave(close = false) {
      if (close && !this.okToClose) {
        this.errorMessage = "You must enter either an action or a note";
        this.$refs.saveDoneButton.stopLoading();
        return;
      }
      console.log(
        "Call handleSave, " + this.selectedAction + " " + this.actionNote
      );
      this.$root.api.updateUrgentSessionNote(
        this.sessionNote.id,
        this.$root.user.token,
        () => {
          if (close) {
            this.$emit("closedUrgentAlert", this.sessionNote.id); // instructs parent view to remove this urgent alert from the list
            this.$root.decrementUnreadUrgentNotesCount();
            this.$refs.saveDoneButton.stopLoading();
            this.hide();
          } else {
            this.$refs.saveButton.stopLoading();
          }
          this.$emit("actionSaved");
        },
        this.sessionNote.action,
        this.sessionNote.action_notes,
        close
      );
    },
  },
};
</script>
<style scoped>
.hide {
  display: none;
}
</style>
